$(document).ready(function() {
  $('.product-meta__included--variant').each(function() {
    var inputText = $(this).text().trim();
    var quantity = parseInt(inputText.split(' ')[0]);
    var itemName = inputText.split(' ').slice(1).join(' ');
    var outputText;
    if (quantity === 1) {
      outputText = convertToSingular(itemName);
    } else {
      outputText = convertToPlural(itemName);
    }
  $(this).text(quantity + ' ' + outputText);
  });
});

function convertToPlural(singular) {
  if (singular.endsWith('y') && !isVowel(singular.charAt(singular.length - 2))) {
    return singular.slice(0, -1) + 'ies';
  } else if (singular.endsWith('sh') || singular.endsWith('ch') || singular.endsWith('x')) {
    return singular + 'es';
  } else if (singular.endsWith('fe')) {
    return singular.slice(0, -2) + 'ves';
  } else if (singular.endsWith('lf')) {
    return singular.slice(0, -1) + 'ves'; // corrected to slice(0, -2) + 'ves' if it's meant to handle 'half'
  } else if (singular.endsWith('s')) {
    return singular; // corrected to return singular + 'es' if it's meant to handle words already ending in 's'
  } else {
    return singular + 's';
  }
}

function convertToSingular(plural) {
  if (plural.endsWith('ies') && !isVowel(plural.charAt(plural.length - 4))) {
    return plural.slice(0, -3) + 'y';
  } else if (plural.endsWith('ses') || plural.endsWith('shes') || plural.endsWith('ches') || plural.endsWith('xes')) {
    return plural.slice(0, -2);
  } else if (plural.endsWith('ves')) {
    return plural.slice(0, -3) + 'fe';
  } else if (plural.endsWith('s')) {
    return plural.slice(0, -1);
  } else {
    return plural;
  }
}

function isVowel(char) {
  return ['a', 'e', 'i', 'o', 'u'].includes(char.toLowerCase());
}

$(document).ready(function(){
 var variantId = $('.product-variant-id').val();
  setTimeout(function(){
  $('.specs__value span').each(function(){
     var dathtml = $(this).attr('meta_var_id');
    if(dathtml){
      if(variantId == dathtml){
          $(this).css("display","block");
        }else{
           $(this).css("display","none");
        }
    }
     });

    }, 400);
  $('.select__select').on('change', function(){
    setTimeout(function(){
      var currentURL = window.location.href;
    var urlParams = new URLSearchParams(new URL(currentURL).search);
    var variantId = urlParams.get("variant");
      $('.specs__value span').each(function(){ 
        var dathtml = $(this).attr('meta_var_id');
      
       if(variantId == dathtml){
          $(this).css("display","block");
        }else{
           $(this).css("display","none");
        }
        });

    }, 400);
 });

  $('#searchInputs').on('input', function() {
    var searchValue = $(this).val().toLowerCase();
    var displayed = 0;
    var found = false; 
    
    $(".collection-list .collection-list__item").each(function() {
        var data_search_1 = $(this).find(".card__heading a").text();
       var text = $(this).text().toLowerCase();
        
        if (text.includes(searchValue)) {
            found = true;
            $(this).addClass("custom_active");
            $(this).css('display', 'block');
           $('.pagination-wrapper').hide();
        } else {
            $(this).hide();
        }
    });

   

    if (!found) {
       $('.not-found-message').show();
    } else {
        $(".not-found-message").hide();
    }
});

});

$('document').ready(function(){
  if($('body').hasClass('template-search')){
    setTimeout(function(){
      $('.boost-sd__sorting-list li').removeClass('boost-sd__sorting-option--active');
      $('.boost-sd__sorting-list li').each(function() {
        var list_val = $(this).text();
        if(list_val === 'Date, New to Old'){
          $(this).addClass('boost-sd__sorting-option--active');
        }
      });
    }, 3000);
  }
});


// 
 $(document).ready(function() {
 $('.left-slide-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  draggable: true,
  fade: true,
   arrows: false,
  dots: false,
  asNavFor: '.right-slide-nav',
     responsive: [
    {
      breakpoint: 989,
      settings: {
         slidesToShow: 1,
  slidesToScroll: 1,
        dots: true
      }
    }
  ]
});
$('.right-slide-nav').slick({
   slidesToShow: 5,
        slidesToScroll: 1,
        centerMode: true,
        arrows: true,
        dots: false,
        speed: 300,
        centerPadding: '20px',
        infinite: true,
        autoplaySpeed: 1000,
       
  asNavFor: '.left-slide-for',
     responsive: [
    {
      breakpoint: 989,
      settings: {
        slidesToShow: 3,
         centerMode: false,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
    });
});
// 

 $(document).ready(function() {
var modal = document.querySelector(".modal");
var trigger = document.querySelector(".trigger");
var closeButton = document.querySelector(".close-button");

function toggleModal() {
    modal.classList.toggle("show-modal");
}

function windowOnClick(event) {
    if (event.target === modal) {
        toggleModal();
    }
}

trigger.addEventListener("click", toggleModal);
closeButton.addEventListener("click", toggleModal);
window.addEventListener("click", windowOnClick);
});
// 
 $(document).ready(function() {
  
   $(".trigger").click(function(){
      $('body').addClass('modal-body')
    });
   
  $('.close-button').click(function() {
    $('body').removeClass('modal-body');
  });
   
 });
$(document).ready(function(){
        var onload_color = $('.color__block input[type="radio"]:checked').val();
        $('.custom__color_name option').prop('selected', false); 
        $(".custom__color_name option[data-option='" + onload_color + "']").prop("selected", true);
        var onload_meta = $(".custom__color_name").val(); 
        $('.select_variant_name').html(onload_meta);
   
        $('.color__block input').on('click', function(){
        var title_var = $(this).val(); 
        $('.custom__color_name option').removeAttr('selected');

        var comoboo_cst_mm =  $(".custom__color_name option").map(function () {
            if ($(this).data("option"))
                return $(this).data("option");
        }).get();

        if(jQuery.inArray(title_var.toString(), comoboo_cst_mm) >= 0){   
            $('.custom__color_name option[data-option="' + title_var + '"]').prop("selected", true); 
            var color_meta_name = $(".custom__color_name").val(); 
            $(this).parents('.swatch').find('.select_variant_name').html(color_meta_name);
        } else {
            $(this).parents('.swatch').find('.select_variant_name').html(title_var);
        }
    });
});